import moment from "moment";
import React, { useState, useEffect, useCallback } from "react";
import { IoMdCloudDownload, IoIosList, IoIosFolder } from "react-icons/io";
import LoadingPage from "@components/Loading/Loading";
import Reports from "../Reports/Reports";
import AddTicket from "./AddTicket/AddTicket";
import Modal from "react-modal";
import Table from "@components/Table/TableTickets";
import config from "@config";
import apiEndpoints from "@store/apiEndpoints";
import errorFunctions from "@store/errorFunctions";
import referenceLibrary from "@store/referenceLibrary";
import utilityFunctions from "@store/utilityFunctions";
import "../common.css";
import "./Warranties.css";
import RaiseNewTicket from "./RaiseNewTicket/RaiseNewTicket";
import { MdClose } from "react-icons/md";
import CustomerAdd from "../CustomerList/CustomerAdd/CustomerAdd";

const Warranties = ({
  selectedbrandID,
  protectedFetch,
  userInfo,
  role,
  history,
  selectedbrandAll,
}) => {
  const [state, setState] = useState({
    loading: true,
    warranties: [],
    statusFilter: "Open",
    orderBy: "created",
    order: "desc",
    pageSize: 25,
    pageNumber: 1,
    searchFilter: "",
    employeeFilter: 0,
    statusSelector: "0",
    brandidselected: selectedbrandAll,
    totalRows: 0,
    showReport: false,
    nextUrl: "",
    prevUrl: "",
    serviceCenters: [],
    serviceCenterCentrals: [],
    serviceCenterFilter: "",
    showAddTicket: false,
    showAddDevice: false,
    showNewRaiseTicket: false,
    employee: [],
    optionServiceCenterCentrals: [],
    optionServiceCenterHeader: [],
  });

  const sessionInfo = utilityFunctions.getUserInfo();
  const userRole = sessionInfo?.user?.role;
  const user = sessionInfo?.user || {};
  const isInitialMount = React.useRef(true);

  const updateState = (updates) => {
    setState((prev) => ({ ...prev, ...updates }));
  };

  const retrieveEmployeesDropdown = useCallback(() => {
    protectedFetch(
      apiEndpoints.employee.dropdown(),
      "GET",
      null,
      errorFunctions.checkResponseThenJson,
    )
      .then((res) => {
        const sortEmp = res.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
        );
        updateState({ employee: sortEmp });
      })
      .catch(() => {
        console.log("fail");
      });
  }, [protectedFetch]);

  const retrieveServiceCenterDropdown = useCallback(() => {
    updateState({ loading: true });
    protectedFetch(
      apiEndpoints.serviceCenter.dropdown(),
      "GET",
      null,
      errorFunctions.checkResponseThenJson,
    )
      .then((res) => {
        let optionServiceCenterHeader = [];
        res?.forEach((s) => {
          optionServiceCenterHeader.push({
            value: s.id,
            label: s.combine_name,
            isDisabled: s.combine_name?.includes("PTC"),
          });
        });

        updateState({
          loading: false,
          optionServiceCenterHeader: optionServiceCenterHeader,
        });
      })
      .catch(() => {
        console.log("fail");
        updateState({ loading: false });
      });
  }, [protectedFetch]);

  const retrieveServiceCenterCentralsDropdown = useCallback(() => {
    updateState({ loading: true });
    protectedFetch(
      apiEndpoints.serviceCenterCentral.dropdown(),
      "GET",
      null,
      errorFunctions.checkResponseThenJson,
    )
      .then((res) => {
        const optionServiceCenters = res?.map((s) => {
          return {
            value: s.id,
            label: s.name,
            isDisabled: s.name.includes("PTC"),
          };
        });

        updateState({
          loading: false,
          optionServiceCenterCentrals: [
            ...[{ value: 0, label: "Select.." }],
            ...optionServiceCenters,
          ],
        });
      })
      .catch(() => {
        console.log("fail");
        updateState({ loading: false });
      });
  }, []);

  const getBrandIdsForRetrieval = () => {
    if (state.brandidselected === "all" || selectedbrandAll === "all") {
      const userBrands = utilityFunctions.getUserInfo()?.user?.brands || [];
      return {
        brandIds: userBrands
          .filter((e) => e.country === config.country)
          .map((brand) => brand.id)
          .join(","),
      };
    }
    return { id: selectedbrandID };
  };

  const retrieveWarranties = useCallback(
    ({
      id,
      criteriaFilter,
      pageNumber,
      pageRowSize,
      assignedTo,
      status,
      orderingTxt,
      newtickets,
      duedates,
      svcCenter,
      storeLocation,
      brandIds,
    } = {}) => {
      const statusFilter = newtickets
        ? ""
        : criteriaFilter || state.statusFilter;
      updateState({ loading: true });

      const queryFilter =
        state.searchFilter?.length > 0 && !criteriaFilter
          ? `&q=${state.searchFilter}`
          : "";
      const fllterAssignTo = assignedTo ? `&assignedTo=${assignedTo}` : "";
      const fllterServiceCenter = svcCenter
        ? `&service_center=${svcCenter}`
        : "";
      const filterStoreLocation = storeLocation
        ? `&store_location=${storeLocation}`
        : "";
      const filterStatus = status ? `&status=${status}` : "";
      const filterCriteria =
        queryFilter?.length === 0
          ? `&filter_criteria=${statusFilter?.toLowerCase()}`
          : "";
      const newTickets = newtickets ? newtickets : "";
      const dueDates = duedates ? duedates : "";

      const ordering = orderingTxt
        ? `&ordering=${orderingTxt}`
        : state.orderBy?.length > 0
          ? `&ordering=${
              state.order === "asc" ? state.orderBy : "-" + state.orderBy
            }`
          : "";
      const pageSize = `&page_size=${pageRowSize || state.pageSize}`;
      const pageNo = `&page=${pageNumber || state.pageNumber}`;

      let brandIdQuery;
      if (brandIds) {
        if (
          brandIds === "all" ||
          state.brandidselected === "all" ||
          selectedbrandAll === "all"
        ) {
          const userBrands = utilityFunctions.getUserInfo()?.user?.brands || [];
          const allBrandIds = userBrands
            .filter((e) => e.country === config.country)
            .map((brand) => brand.id)
            .join(",");
          brandIdQuery = `?brandIds=${allBrandIds}`;
        } else {
          brandIdQuery = `?brandIds=${brandIds}`;
        }
      } else {
        brandIdQuery = `?brandId=${id || selectedbrandID}`;
      }
      const url =
        config.backendServer +
        `tickets/${brandIdQuery}${filterCriteria}${fllterAssignTo}${queryFilter}${ordering}${pageSize}${pageNo}${filterStatus}${newTickets}${dueDates}${fllterServiceCenter}${filterStoreLocation}`;

      protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
        .then((res) => {
          updateState({
            loading: false,
            warranties: res.results,
            totalRows: res.count,
            nextUrl: res.next,
            prevUrl: res.previous,
          });
        })
        .catch(() => {
          console.log("fail");
          updateState({ loading: false });
        });
    },
    [
      protectedFetch,
      state.statusFilter,
      state.searchFilter,
      state.orderBy,
      state.order,
      state.pageSize,
      state.pageNumber,
    ],
  );

  const handleRefresh = useCallback(() => {
    retrieveEmployeesDropdown();
    retrieveServiceCenterDropdown();
    retrieveWarranties(getBrandIdsForRetrieval());
  }, [
    retrieveEmployeesDropdown,
    retrieveServiceCenterDropdown,
    retrieveWarranties,
    selectedbrandID,
  ]);

  useEffect(() => {
    retrieveEmployeesDropdown();
    retrieveServiceCenterCentralsDropdown();
    retrieveServiceCenterDropdown();
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get("status");
    const assignto = urlParams.get("assignto");
    const allocated = urlParams.get("allocated");
    const newtickets = urlParams.get("newtickets");
    const duedates = urlParams.get("duedates");
    const storeLocation = urlParams.get("store_location");
    const brandIdParams = urlParams.get("brand");

    const getBrandIds = () => {
      if (selectedbrandAll === "all" || brandIdParams) {
        const userBrands = utilityFunctions.getUserInfo()?.user?.brands || [];
        return {
          brandIds: brandIdParams
            ? brandIdParams
            : userBrands
                .filter((e) => e.country === config.country)
                .map((brand) => brand.id)
                .join(","),
        };
      }
      return { id: selectedbrandID };
    };

    const brandParams = getBrandIds();

    // Handle URL parameter-based filtering
    if (assignto > "0") {
      if (assignto === "unassigned") {
        updateState({ statusFilter: "Unassigned" });
        retrieveWarranties({
          ...brandParams,
          criteriaFilter: "Unassigned",
          pageNumber: 1,
          orderingTxt: "-created",
        });
      } else {
        retrieveWarranties({
          ...brandParams,
          pageNumber: 1,
          assignedTo: assignto,
          orderingTxt: "-created",
        });
      }
    } else if (status) {
      retrieveWarranties({
        ...brandParams,
        pageNumber: 1,
        status: status,
        orderingTxt: "-created",
      });
    } else if (allocated) {
      if (allocated === "Not Allocated") {
        updateState({ statusFilter: "Unassigned" });
        retrieveWarranties({
          ...brandParams,
          criteriaFilter: "Unassigned",
          pageNumber: 1,
          orderingTxt: "-created",
        });
      } else if (allocated === "Allocated") {
        updateState({ statusFilter: "Assigned" });
        retrieveWarranties({
          ...brandParams,
          criteriaFilter: "open_and_assigned",
          pageNumber: 1,
          orderingTxt: "-created",
        });
      }
    } else if (newtickets) {
      if (newtickets === "today") {
        retrieveWarranties({
          ...brandParams,
          newtickets: `&created__gte=${moment().format("YYYY-MM-DD")}`,
        });
      } else if (newtickets === "previous") {
        retrieveWarranties({
          ...brandParams,
          newtickets: `&created__gte= ${moment()
            .subtract(1, "days")
            .format(
              "YYYY-MM-DD",
            )}&created__lt=${moment().format("YYYY-MM-DD")}`,
        });
      }
    } else if (duedates) {
      if (duedates === "Today") {
        updateState({ statusFilter: "Open" });
        retrieveWarranties({
          ...brandParams,
          criteriaFilter: "Open",
          duedates: `&due_date=${moment().format("YYYY-MM-DD")}`,
        });
      } else if (duedates === "Tomorrow") {
        updateState({ statusFilter: "Open" });
        retrieveWarranties({
          ...brandParams,
          criteriaFilter: "Open",
          duedates: `&due_date=${moment().add(1, "days").format("YYYY-MM-DD")}`,
        });
      } else if (duedates === "Overdue") {
        updateState({ statusFilter: "Open" });
        retrieveWarranties({
          ...brandParams,
          criteriaFilter: "Open",
          duedates: `&due_date__lt=${moment().format("YYYY-MM-DD")}`,
        });
      } else if (duedates === "2 Days") {
        updateState({ statusFilter: "Open" });
        retrieveWarranties({
          ...brandParams,
          criteriaFilter: "Open",
          duedates: `&due_date=${moment().add(2, "days").format("YYYY-MM-DD")}`,
        });
      } else if (duedates === ">2 Days") {
        updateState({ statusFilter: "Open" });
        retrieveWarranties({
          ...brandParams,
          criteriaFilter: "Open",
          duedates: `&due_date__gt=${moment().add(2, "days").format("YYYY-MM-DD")}`,
        });
      } else if (duedates === "No Due Date") {
        updateState({ statusFilter: "Open" });
        retrieveWarranties({
          ...brandParams,
          criteriaFilter: "Open",
          duedates: `&no_due_date=true`,
        });
      }
    } else if (storeLocation) {
      updateState({ statusFilter: "Open" });
      retrieveWarranties({
        ...brandParams,
        criteriaFilter: "Open",
        storeLocation: storeLocation,
      });
    } else {
      retrieveWarranties(brandParams);
    }
  }, []);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    retrieveWarranties(getBrandIdsForRetrieval());
  }, [selectedbrandID]);

  const filterChange = (e) => {
    updateState({ [e.target.id]: e.target.value });
  };

  const handleKeyPressSearch = (e) => {
    if (e.key === "Enter") {
      updateState({
        statusFilter: "",
        employeeFilter: "",
        statusSelector: "",
        pageNumber: 1,
      });
      retrieveWarranties({ ...getBrandIdsForRetrieval(), pageNumber: 1 });
    }
  };

  const handleBtnSearch = () => {
    updateState({
      statusFilter: "",
      employeeFilter: "",
      statusSelector: "",
      pageNumber: 1,
    });
    retrieveWarranties({ ...getBrandIdsForRetrieval(), pageNumber: 1 });
  };

  const handleFilterStatus = (val) => {
    const statusText =
      referenceLibrary.statusSelectors.find((x) => x.id === parseInt(val))
        ?.name || "";
    if (statusText === "") {
      updateState({ statusSelector: "0" });
      retrieveWarranties({
        ...getBrandIdsForRetrieval(),
        pageNumber: 1,
        assignedTo: state.employeeFilter,
        orderingTxt: "-created",
      });
    } else {
      updateState({ statusSelector: val });
      retrieveWarranties({
        ...getBrandIdsForRetrieval(),
        pageNumber: 1,
        assignedTo: state.employeeFilter,
        status: statusText,
        orderingTxt: "-created",
      });
    }
  };

  const handleSelectBrandID = (brandID) => {
    updateState({ brandidselected: brandID });
    if (brandID === "all") {
      // Get all brand IDs from user info for "All Brands" option
      const userBrands = utilityFunctions.getUserInfo()?.user?.brands || [];
      const allBrandIds = userBrands
        .filter((e) => e.country === config.country)
        .map((brand) => brand.id)
        .join(",");
      retrieveWarranties({ brandIds: allBrandIds });
    } else {
      retrieveWarranties({ brandIds: brandID });
    }
  };

  const handleFilterAssignTo = (employeeID) => {
    updateState({
      employeeFilter: employeeID,
      pageNumber: 1,
    });
    const statusText =
      referenceLibrary.statusSelectors.find(
        (x) => x.id === parseInt(state.statusSelector),
      )?.name || "";
    if (employeeID > "0") {
      retrieveWarranties({
        ...getBrandIdsForRetrieval(),
        pageNumber: 1,
        assignedTo: employeeID,
        status: statusText,
        orderingTxt: "-created",
      });
    } else {
      updateState({
        employeeFilter: "",
      });
      retrieveWarranties({
        ...getBrandIdsForRetrieval(),
        pageNumber: 1,
        status: statusText,
        orderingTxt: "-created",
      });
    }
  };

  const handleFilterServiceCenter = (serviceCenterId) => {
    updateState({
      serviceCenterFilter: serviceCenterId,
      pageNumber: 1,
    });
    const statusText =
      referenceLibrary.statusSelectors.find(
        (x) => x.id === parseInt(state.statusSelector),
      )?.name || "";
    if (serviceCenterId > "0") {
      retrieveWarranties({
        ...getBrandIdsForRetrieval(),
        pageNumber: 1,
        status: statusText,
        orderingTxt: "-created",
        svcCenter: serviceCenterId,
      });
    } else {
      updateState({
        serviceCenterFilter: "",
      });
      retrieveWarranties({
        ...getBrandIdsForRetrieval(),
        pageNumber: 1,
        status: statusText,
        orderingTxt: "-created",
      });
    }
  };

  const statusFilterChange = (value) => {
    updateState({
      statusFilter: value,
      searchFilter: "",
      employeeFilter: "",
      statusSelector: "",
      pageNumber: 1,
      order: "desc",
      orderBy: "created",
    });
    retrieveWarranties({
      ...getBrandIdsForRetrieval(),
      criteriaFilter: value,
      pageNumber: 1,
      orderingTxt: "-created",
    });
  };

  const formatValueWithCommas = (value) => {
    if (value === "") return value;

    const parts = value.toString().split(".");
    let formattedValue = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (parts.length > 1) {
      const decimalPart = parts[1].slice(0, 2);
      formattedValue += `.${decimalPart}`;
    }

    return formattedValue;
  };

  // const getColorByTicketCombination = (ticketType, typeOfService) => {
  //   const combinationKey = `${ticketType}_${typeOfService}`;

  //   const colorMap = {
  //     warranty_service: "#FFD700",
  //     warranty_repair: "#ADD8E6",
  //     out_of_warranty_service: "#90EE90",
  //     out_of_warranty_repair: "#FFB6C1",
  //   };

  //   return colorMap[combinationKey] || "transparent";
  // };

  let warranties = state.warranties;
  let filteredWarranties = [];
  warranties.map((val) => filteredWarranties.push(val));

  const getBrandColumn = () => {
    if (state.brandidselected === "all" || selectedbrandAll === "all") {
      return {
        id: "brand",
        filter: "brand",
        label: "Brand",
        valueDisplay: (value) => value,
      };
    }
    return null;
  };

  const tableHead = [
    {
      id: "ticket_number",
      filter: "ticket_id",
      label: "ID",
      valueDisplay: (value) => value,
    },
    {
      id: "date_received",
      filter: "created",
      label: "Received Date",
      defaultSort: "desc",
      valueDisplay: (value) => moment(value).format("DD-MM-YYYY"),
    },
    {
      id: "last_activity_date",
      filter: "last_activity_date",
      label: "Last Activity Date",
      valueDisplay: (value) => moment(value).format("DD-MM-YYYY"),
    },
    {
      id: "ticket_type",
      filter: "ticket_type",
      label: "Ticket Type",
      valueDisplay: (value) => value || "(missing)",
    },
    {
      id: "device_name",
      filter: "user_device__device__name",
      label: "Device Name",
      width: "200px",
      valueDisplay: (value) => value || "(missing)",
    },
    {
      id: "owner_name",
      filter: "user_device__customer__first_name",
      label: "Owner Name",
      width: "180px",
      valueDisplay: (value) => value || "(missing)",
    },
    {
      id: "solvup_id",
      filter: "solvup_id",
      label: "Solvup ID",
      valueDisplay: (value) => value,
    },
    getBrandColumn(),
    {
      id: "refund_amount",
      filter: "refund_amount",
      label: "Refund Amount",
      width: "70px",
      noAccessRole: ["Commercial Admin", "Commercial Staff"],
      valueDisplay: (value) => `$ ${formatValueWithCommas(value)}`,
    },
    {
      id: "status",
      filter: "status",
      label: "Status",
      width: "100px",
      valueDisplay: (value) => value || "(missing)",
    },
    {
      id: "service_center",
      filter: "service_center",
      label: "Service Center",
      width: "100px",
      valueDisplay: (value) => value,
    },
    {
      id: "assigned_to",
      filter: "assigned_to__employee__first_name",
      label: "Assigned To",
      valueDisplay: (value) => value,
    },
    {
      id: "created_by_role",
      filter: "created_by_role",
      label: "Created By",
      width: "100px",
      valueDisplay: (value) => value,
    },
    {
      id: "due_date",
      filter: "due_date",
      label: "Due Date",
      noAccessRole: ["Commercial Admin", "Commercial Staff"],
      valueDisplay: (value) => value,
    },
  ].filter(Boolean);

  return (
    <div className={"page"}>
      <div
        className={
          "pageHeader d-flex justify-content-between align-items-center mb-2"
        }
      >
        <div className="border-bottom ml-2">
          {userInfo?.user.role.includes("Commercial") && (
            <div className="text-start mb-2" style={{ fontSize: "14px" }}>
              <div>Store : {userInfo?.user.seller}</div>
              <div>Location : {userInfo?.user.store_location}</div>
            </div>
          )}
          <h5>Tickets</h5>
        </div>

        {["Admin", "Service Center Admin"].includes(userRole) && (
          <button
            className="k-btn k-btn-primary k-btn-sm d-flex gap-2"
            onClick={() => updateState({ showReport: true })}
          >
            <IoMdCloudDownload
              className="my-auto"
              title="Export Report to Excel"
            />{" "}
            <span className="my-auto">Export Report</span>
          </button>
        )}

        {["Commercial Staff", "Commercial Admin"].includes(userRole) && (
          <div className="d-flex flex-row gap-2">
            <button
              className="k-btn k-btn-primary k-btn-sm d-flex gap-2"
              onClick={() => updateState({ showNewRaiseTicket: true })}
            >
              <IoIosFolder className="my-auto" title="Raise New Ticket" />
              <span className="my-auto">Raise New Ticket</span>
            </button>
            <button
              className="k-btn k-btn-primary k-btn-sm d-flex gap-2"
              onClick={() => updateState({ showAddDevice: true })}
            >
              <IoIosFolder className="my-auto" title="Register Device" />
              <span className="my-auto">Register Device</span>
            </button>
            <button
              className="k-btn k-btn-primary k-btn-sm d-flex gap-2"
              onClick={() => updateState({ showAddTicket: true })}
            >
              <IoIosList className="my-auto" title="Assign Existing Device" />
              <span className="my-auto">Assign Existing Device</span>
            </button>
          </div>
        )}
      </div>

      <div
        className="row border-1 rounded"
        style={{ border: "1px solid lightgray", margin: "1px" }}
      >
        <div className={"p-3 col-md-7 mr-auto "}>
          <>
            <div className="form-check form-check-inline">
              <input
                style={{ marginTop: "5px" }}
                className="form-check-input"
                type="radio"
                name="exampleRadios"
                id="all"
                value={state.statusFilter}
                checked={state.statusFilter === "All"}
                onChange={(e) => {
                  if (e.target.checked) {
                    statusFilterChange("All");
                  }
                }}
              />
              <label className="form-check-label" htmlFor="all">
                All
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                style={{ marginTop: "5px" }}
                className="form-check-input"
                type="radio"
                name="exampleRadios"
                id="open"
                value="Open"
                checked={state.statusFilter === "Open"}
                onChange={(e) => {
                  if (e.target.checked) {
                    statusFilterChange("Open");
                  }
                }}
              />
              <label className="form-check-label" htmlFor="open">
                Open
              </label>
            </div>
            {!["Commercial Admin", "Commercial Staff"].includes(user.role) && (
              <div className="form-check form-check-inline">
                <input
                  style={{ marginTop: "5px" }}
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="assigned"
                  value="Assigned"
                  checked={state.statusFilter === "Assigned"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      statusFilterChange("Assigned");
                    }
                  }}
                />
                <label className="form-check-label" htmlFor="assigned">
                  Assigned
                </label>
              </div>
            )}
            {!["Commercial Admin", "Commercial Staff"].includes(user.role) && (
              <div className="form-check form-check-inline">
                <input
                  style={{ marginTop: "5px" }}
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="unassigned"
                  value="Unassigned"
                  checked={state.statusFilter === "Unassigned"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      statusFilterChange("Unassigned");
                    }
                  }}
                />
                <label className="form-check-label" htmlFor="unassigned">
                  Unassigned
                </label>
              </div>
            )}
            {!["Commercial Admin", "Commercial Staff"].includes(user.role) && (
              <div className="form-check form-check-inline">
                <input
                  style={{ marginTop: "5px" }}
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="myticket"
                  value="MyTicket"
                  checked={state.statusFilter === "My_Ticket"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      statusFilterChange("My_Ticket");
                    }
                  }}
                />
                <label className="form-check-label" htmlFor="myticket">
                  My tickets
                </label>
              </div>
            )}
            <div className="form-check form-check-inline">
              <input
                style={{ marginTop: "5px" }}
                className="form-check-input"
                type="radio"
                name="exampleRadios"
                id="archived"
                value="Archived"
                checked={state.statusFilter === "Archived"}
                onChange={(e) => {
                  if (e.target.checked) {
                    statusFilterChange("Archived");
                  }
                }}
              />
              <label className="form-check-label" htmlFor="archived">
                {!["Commercial Admin", "Commercial Staff"].includes(user.role)
                  ? "Archived"
                  : "Closed"}
              </label>
            </div>
          </>
        </div>

        <div className={"col-md-5 pt-2"} style={{ paddingLeft: "10vw" }}>
          <div className="input-group  mb-3 ">
            <input
              type="text"
              placeholder="Search tickets"
              id={"searchFilter"}
              className={"form-control"}
              onChange={filterChange}
              onKeyDown={handleKeyPressSearch}
              value={state.searchFilter}
              width={"70px"}
            />
            <div className="input-group-prepend">
              <span className="form-control " onClick={handleBtnSearch}>
                <i className="fa fa-search form-control-icon"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className={"pageContent clearfix"}>
        {state.loading && <LoadingPage />}
        <div className={"admin-table-container card"}>
          <Table
            head={tableHead}
            data={filteredWarranties}
            filterServiceCenter={(val) => handleFilterServiceCenter(val)}
            serviceCenters={state.serviceCenters}
            serviceCenterCentrals={state.serviceCenterCentrals}
            serviceCenter={state.serviceCenterFilter}
            optionServiceCenterCentrals={state.optionServiceCenterCentrals}
            optionServiceCenterHeader={state.optionServiceCenterHeader}
            employee={state.employee}
            reloadMini={() => retrieveWarranties(selectedbrandID)}
            protectedFetch={protectedFetch}
            selectedbrandID={selectedbrandID}
            role={userRole}
            statusSelectors={referenceLibrary.statusSelectors}
            statusSelector={state.statusSelector}
            changeStatusSelector={(val) => updateState({ statusSelector: val })}
            onOrder={(val) => updateState({ order: val })}
            onOrderBy={(orderBy_) => updateState({ orderBy: orderBy_ })}
            order={state.order}
            orderBy={state.orderBy}
            filteredStatus={(val) => handleFilterStatus(val)}
            statusFilter={state.statusFilter}
            filterAssignTo={(val) => handleFilterAssignTo(val)}
            brandidselected={state.brandidselected}
            handleSelectBrandID={(val) => handleSelectBrandID(val)}
            optionBrandName={sessionInfo?.user?.brands || []}
            assignedTo={state.employeeFilter}
            totalRows={state.totalRows}
            rowsPerPage={state.pageSize}
            rowsPerPageChg={(val) => updateState({ pageSize: val })}
            pageNumber={state.pageNumber}
            pageNumberChg={(val) => updateState({ pageNumber: val })}
            retrieveWarranty={(
              pageNumber,
              pageRowSize,
              assignTo,
              status,
              ordering,
            ) =>
              retrieveWarranties({
                ...getBrandIdsForRetrieval(),
                criteriaFilter: state.statusFilter,
                pageNumber,
                pageRowSize,
                assignedTo: assignTo,
                status,
                orderingTxt: ordering,
              })
            }
          />
        </div>
      </div>

      <Modal
        isOpen={state.showReport}
        contentLabel={"Export Report"}
        className={"input-modal"}
      >
        <Reports
          protectedFetch={protectedFetch}
          handleCloseModal={() => updateState({ showReport: false })}
        />
      </Modal>

      <Modal
        isOpen={state.showAddTicket}
        contentLabel={"Add Tickets"}
        className={"input-modal-lg"}
      >
        <AddTicket
          data={filteredWarranties}
          protectedFetch={protectedFetch}
          handleCloseModal={() => updateState({ showAddTicket: false })}
          selectedbrandID={selectedbrandID}
          userInfo={userInfo}
          retrieveWarranty={() => retrieveWarranties(getBrandIdsForRetrieval())}
        />
      </Modal>

      <Modal
        isOpen={state.showAddDevice}
        contentLabel={"Add New Device."}
        className={"input-modal"}
      >
        <button
          onClick={() => updateState({ showAddDevice: false })}
          className={"info-modal-close"}
        >
          <MdClose />
        </button>
        <CustomerAdd
          protectedFetch={protectedFetch}
          handleCloseModal={() => updateState({ showAddDevice: false })}
          handleRefresh={() => handleRefresh()}
          handleRetrieveCustomerList={() => {}}
          selectedBrandId={selectedbrandID}
          role={role}
          userInfo={userInfo}
          isRegisterDevice={true}
        />
      </Modal>

      <Modal
        isOpen={state.showNewRaiseTicket}
        contentLabel={"Raise New Ticket"}
        className={"input-modal-lg"}
      >
        <RaiseNewTicket
          protectedFetch={protectedFetch}
          handleCloseModal={() => updateState({ showNewRaiseTicket: false })}
          handleRefresh={() => {
            retrieveWarranties(getBrandIdsForRetrieval());
          }}
          retrieveWarranty={() => retrieveWarranties(getBrandIdsForRetrieval())}
          selectedbrandID={selectedbrandID}
          userInfo={userInfo}
          history={history}
        />
      </Modal>
    </div>
  );
};

export default Warranties;
